import { useContext, useEffect, useState } from "react";
import AntdTable from "../../../antd/Table/Table";
import { filtrationcontext } from "../../../../context/Filtercontext";
import trans, { isRTL } from "../../../../utils";
import { exportContext } from "../../../../context/ExportDataContext";
import dayjs from "dayjs";
import { Table } from "antd";
import AssignmentHistoryPopup from "./AssignmentHistoryPopup";
import { useReportTableColumns } from "../../ReportColumns/reportColumns";

const DeviceAssignmentReportTable = ({
  startDate,
  endDate,
  currentPage,
  setCurrentPage,
  data,
  isLoading,
  selectedids,
  filters,
}) => {
  const { setFileName, setExportIds, setStartDateE, setEndDateE } =
    useContext(exportContext);
  const {
    setSort: SetSortFilter,
    limit,
    setLimit,
  } = useContext(filtrationcontext);
  const [sort, setSort] = useState({
    by: "",
    order: "",
  });
  const [selectedDevice, setSelectedDevice] = useState({
    deviceId: null,
    deviceName: null,
  });

  useEffect(() => {
    return () => {
      SetSortFilter({ type: "", value: "" });
      localStorage.setItem("page", 1);
    };
  }, [SetSortFilter]);

  const columns = [
    {
      key: "device_name",
      title: trans("Device Name"),
      dataIndex: "device_name",
      sorter: true,
      width: 200,
      fixed: !isRTL ? "left" : undefined,
      render: (name) => (
        <span className={"table-element-name ps-0"}>{name}</span>
      ),
    },
    {
      key: "device_type",
      title: trans("Device Type"),
      dataIndex: "device_type",
      width: 150,
      sorter: true,
      fixed: !isRTL ? "left" : undefined,
    },
    {
      key: "current_user_name",
      title: trans("Current User"),
      dataIndex: "current_user_name",
      width: 150,
      sorter: true,
    },
    {
        key: "current_assignment_date",
        title: trans("Current Login Date"),
        dataIndex: "current_assignment_date",
        width: 200,
        sorter: true,
        render: (date) => date ? dayjs(date).format("DD/MM/YYYY HH:mm") : "- - - - -",
    },
    {
        key: "total_assignments",
        title: trans("Total Logins"),
        dataIndex: "total_assignments",
        sorter: true,
        width: 150,
    },
        {
        key: "total_users",
        title: trans("Total Users"),
        dataIndex: "total_users",
        sorter: true,
        width: 150,
    },
    {
        key: "first_assignment_date",
        title: trans("First Login Date"),
        dataIndex: "first_assignment_date",
        width: 200,
        sorter: true,
        render: (date) => date ? dayjs(date).format("DD/MM/YYYY HH:mm") : "- - - - -",
    },
    {
        key: "total_duration_days",
        title: trans("Total Duration Days"),
        dataIndex: "total_duration_days",
        sorter: true,
        width: 200,
    }
  ];
  const visibleColumns = useReportTableColumns(columns);

  useEffect(() => {
    if (data) {
      setStartDateE(startDate);
      setEndDateE(endDate);
    }
  }, [data, startDate, endDate, selectedids]);

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      SetSortFilter({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      SetSortFilter({
        by: "",
        order: "",
      });
    }
  };

  const handleRowClick = (record) => {
    setSelectedDevice({
      deviceId: record.id,
      deviceName: record.device_name,
    });
  };

  const handleModalClose = () => {
    setSelectedDevice({
      deviceId: null,
      deviceName: null,
    });
  };

  return (
    <div className="bg-white-rounded-top mt-3 table-parent">
      <Table
        columns={visibleColumns}
        dataSource={data?.devices || []}
        loading={isLoading}
        pagination={{
          current: currentPage,
          pageSize: limit,
          total: data?.pagination?.total_items || 0,
          onChange: (page, pageSize) => {
            setCurrentPage(page);
            setLimit(pageSize);
          },
        }}
        onChange={handleTableChange}
        scroll={{ y: 350, x: true }}
        rowKey={(record) => record.device_id}
        onRow={(record) => ({
          onClick: () => handleRowClick(record),
          style: { cursor: 'pointer' }
        })}
      />

      {selectedDevice.deviceId && (
        <AssignmentHistoryPopup
          deviceId={selectedDevice.deviceId}
          deviceName={selectedDevice.deviceName}
          onClose={handleModalClose}
        />
      )}
    </div>
  );
};

export default DeviceAssignmentReportTable;
